import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { InfoBox } from '../common'

const AveragePrice = ({ delta, isEmpty, loading, price, t }) => (
    <InfoBox isEmpty={isEmpty} loading={loading} title={t('Average Price')} value={`${(price || 0).toFixed(2)}€`} delta={delta} />
)

AveragePrice.propTypes = {
    isEmpty: PropTypes.bool,
    loading: PropTypes.number,
    price: PropTypes.number,
    delta: PropTypes.number,
    t: PropTypes.func.isRequired,
}

AveragePrice.defaultProps = {
    isEmpty: true,
    loading: null,
    price: 0,
    delta: 0,
}

export default withTranslation()(AveragePrice)
